import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {getText, renderMarkdown} from 'helpers/text-helper';
import {branchesData} from 'data/branches-data';
import {themesData} from 'data/themes-data';
import YouTube from 'react-youtube';
import './create-game.scss';

const CreateGame = ({languageId, deviceInfo, createNewGame, goToPage}) => {
	/* Loading status */
	const [isLoading, setIsLoading] = useState(false);

	const [showIntroVideo, setShowIntroVideo] = useState(true);

	/* Selected branch */
	const [branchId, setBranchId] = useState(null); 

	/* Error message */
	const [errMsg, setErrMsg] = useState(null);

	const videoId = 'Nlb1vXsTp8k';

	
	/* Video state and ref */
	const [videoState, setVideoState] = useState('loading');
	const [videoRef, setVideoRef] = useState(null);

	const selectedBranchData = branchesData.find((branch) => {
		return branch.id === branchId;
	});

	/**
	 * Start video
	 * @param {object} e 
	 * @returns 
	 */
	const handlePlay = (e) => {
		e.stopPropagation();
		if (videoState === 'loading') return;
		if (videoRef && videoRef.playVideo) {
			setVideoState('buffering');
			videoRef.playVideo();
		}
	};

	const handleEnd = () => {
		setVideoState('ended');
		if (document && document.fullscreenElement) {
			setTimeout(() => {return document.exitFullscreen();}, 100);
		}
		setTimeout(() => {setShowIntroVideo(false);}, 200);
	};

	/**
	 * Creates a new game, and if successful, go to game status page
	 */
	const handleCreateGame = (themeId) => {
		if (isLoading) return;

		setIsLoading(true);
		createNewGame(branchId, themeId).then((response) => {
			if (response.status === 'success') {
				setIsLoading(false);
				goToPage('game-intro');
			} else {
				setErrMsg(response.error);
				setIsLoading(false);
			}
		});
	};

	/* Choose branch */
	if (!selectedBranchData) {
		return (
			<div className={'CreateGame ' + deviceInfo.orientation}>
				{/* Home btn */}
				<div className="CreateGame-homeBtn" onClick={() => {goToPage('settings');}} />

				{/* Logo */}
				<div className="CreateGame-logo" />

				{/* Content */}
				<div className='CreateGame-content branch'>
					<div className='CreateGame-title'>
						<span>{getText('pages_chooseBranchTitle', languageId)}</span> 
					</div>
					<div className='CreateGame-text'>
						{renderMarkdown(getText('pages_chooseBranchText', languageId))}
					</div>
					<div className='CreateGame-branches'>
						{branchesData.map((branch, index) => {
							return (
								<div 
									key={index} 
									className={'CreateGame-branch ' + branch.id 
										+ (!branch.isActive ? ' inactive' : '')}
									onClick={() => {if (branch.isActive) setBranchId(branch.id);}}
								>
									<span>{getText(branch.title, languageId)}</span>
								</div>
							);
						})}
					</div>
				</div>
			</div>
		);
	}

	if (showIntroVideo) {
		return (
			<div className={'CreateGame ' + deviceInfo.orientation}>
				<div className="CreateGame-logo" />
				<div className="CreateGame-homeBtn" onClick={() => {goToPage('settings');}} />

				<div className='CreateGame-content introvideo'>
					<div className='CreateGame-title'>
						<span>{getText('pages_chooseBranchTitle', languageId)}</span> 
					</div>
					<div className='CreateGame-text'>
						{renderMarkdown(getText('pages_introVideoText', languageId))}
					</div>
					<div className="CreateGame-videoWrap">
						<YouTube 
							className={'CreateGame-video ' + videoState} 
							videoId={videoId} 
							onReady={(e) => {setVideoRef(e.target); setVideoState('ready');}}
							onPlay={() => {setVideoState('playing');}}
							onPause={() => {setVideoState('paused');}}
							onEnd={() => {handleEnd();}}
							opts={{
								height: '100%', 
								width: '100%', 
								playerVars: {
									controls: 1,
								}
							}}
						/>
						<div 
							className={'CreateGame-videoPlayBtn ' + videoState} 
							onClick={(e) => {handlePlay(e);}} 
						/>
					</div>
				</div>
			</div>
		);
	}

	/* Choose theme */
	return (
		<div className={'CreateGame ' + deviceInfo.orientation}>
			<div className="CreateGame-logo" />
			<div className="CreateGame-homeBtn" onClick={() => {goToPage('settings');}} />

			{/* Content */}
			<div className='CreateGame-content theme'>
				<div className='CreateGame-title'>
					<span>{getText(selectedBranchData.title, languageId)}</span> 
				</div>
				<div className='CreateGame-text'>
					{renderMarkdown(getText('pages_chooseThemeText', languageId))}
				</div>
				<div className='CreateGame-themes'>
					{themesData.filter((theme) => {return theme.branchId === branchId;}).map((theme, index) => {
						return (
							<div 
								key={index} 
								className={'CreateGame-theme ' + theme.id + (isLoading ? ' loading' : '') 
									+ (!theme.isActive ? ' inactive' : '')}
								onClick={() => {if (theme.isActive) handleCreateGame(theme.id);}}
							>
								<span>{getText(theme.subtitle, languageId)}</span>
							</div>
						);
					})}
				</div>
			</div>

			{/* Error msg */}
			<div className='CreateGame-feedback'>
				{errMsg && <span>{errMsg}</span>}
			</div>		
		</div>
	);
};

CreateGame.propTypes = {
	languageId: PropTypes.string.isRequired,
	deviceInfo: PropTypes.object.isRequired,
	goToPage: PropTypes.func.isRequired,
	createNewGame: PropTypes.func.isRequired,
};

export default CreateGame;